import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ModalService } from '../../../../services/modal.service';
import { showErrorMessage } from '../../../../utils/utils';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CampaignStatusPipe } from '../../../../pipes/campaignStatus.pipe';
import { ARColzaCampaign, ARColzaCampaignConfiguration } from '../../../../models/agrorendement-colza.model';
import { Page } from '../../../../models/page.model';
import { ARColzaService } from '../../../../services/agrorendement-colza.service';
import { ARColzaCampaignConfigurationEditComponent } from './campaign-config-edit.component';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-colza-campaigns-cmp',
  templateUrl: 'campaigns.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ARColzaCampaignConfigurationEditComponent, CampaignYearPipe, CampaignStatusPipe, TranslatePipe, CommonModule, FormsModule, PaginationModule],
  providers: [ARColzaService],
})
export class ARColzaCampaignComponent implements OnInit, AfterViewInit {
  error: any;
  //@ViewChild('filter') filterElement: ElementRef;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';

  constructor(
    private colzaService: ARColzaService,
    private modal: ModalService,
    private router: Router,
  ) {}

  getCampaignsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.colzaService
      .getPageCampaigns(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<ARColzaCampaign>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addCampaignConfiguration(campaign: ARColzaCampaign) {
    this.router.navigate(['/orders', 'azote', 'colza', 'admin', 'new', campaign.id]);
  }

  deleteCampaignConfiguration(config: ARColzaCampaignConfiguration, event: any) {
    event.stopPropagation();
    // FIXME traiter les erreurs
    this.colzaService.deleteCampaignConfiguration(config).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => this.handleError(error, 'Impossible de supprimer la configuration'),
    );
  }

  handleError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }

  editCampaignConfiguration(config: ARColzaCampaignConfiguration, event: any) {
    this.router.navigate(['/orders', 'azote', 'colza', 'admin', 'edit', config.id]);
  }

  ngOnInit() {
    this.onChangeTable();
  }

  ngAfterViewInit() {}

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.getCampaignsPaginated(pageNumber, null, null, this.filter);
  }
}
